import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Router } from '@angular/router';

@Injectable()
export class BackButtonService {
  
  constructor(private router: Router) { }

  private paperType: string;
  private staticPaperType:string;
  
  setPaperType(paperType){
    this.paperType = paperType;
  }
    
  getPaperType(){
    return this.paperType;
  }
  
  setStaticType(staticPaperType){
    this.staticPaperType = staticPaperType;
  }

  getStaticType(){
    return this.staticPaperType;
  }

}



// WEBPACK FOOTER //
// /usr/share/nginx/grade5_live/grade5-frontend-2.0/src/app/shared/services/back-button.service.ts